import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useMoment() {
  return {
    moment: GlobalPrototypes.moment,
  }
}
